import Fetch from "@/utils/Fetch"
import objectToFormData from "@/utils/ObjectToFormData";

export default {
	namespaced: true,
	state() {
		return {
			userData: JSON.parse(sessionStorage.getItem('user-data')) || null,
			fullUserData: null,
			userNotice: 0,
			userBanner: []
		}
	},
	mutations: {
		setUserData(state,userData) {
			state.userData = userData
			sessionStorage.setItem('user-data', JSON.stringify(userData))
			sessionStorage.removeItem('product-groups')
		},
		setFullUserData(state,userData) {
			state.fullUserData = userData
		},
		clearUserData(state) {
			state.userData = null
			sessionStorage.removeItem('user-data')
			sessionStorage.removeItem('product-groups')
		},

		setUserNotice(state, value) {
			state.userNotice = value
		},
		
		setUserInfoBanner(state, value) {
			state.userBanner= value
		}
	},
	actions: {
		async requestUserAuth({commit}, form) {
			commit('startLoading', 'requestUserAuth', {root: true})

			const body = objectToFormData({
				login: form.login,
				password: form.password,
				remember: form.remember,
				token: form.token
			})

			const response = await Fetch('user/auth/', {
				method: "POST",
				body,
			})
			if(response.success) {
				commit('setUserData', response.data)
			}

			commit('stopLoading', 'requestUserAuth', {root: true})

			return {
				...response
			}
		},

		async requestUserData({commit, getters,dispatch}) {
			if(!getters.getUserData) {
				const response = await Fetch('user/', {
					method: 'GET',
				});

				if (response.success) {
					commit('setUserData', response.data)
				} else {
					dispatch('showError', response.message, {root: true})
				}

				return {
					...response.data
				}
			} else {
				return {
					...getters.getUserData
				}
			}
		},		
		
		async requestFullUserData({commit,dispatch}) {
			commit('startLoading', 'requestFullUserData', {root: true})
			const response = await Fetch('user/full/', {
				method: 'GET',
			});

			if (response.success) {
				commit('setFullUserData', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestFullUserData', {root: true})

			return {
				...response.data
			}
		},

		async requestLogoutUser({commit}) {
			const response = await Fetch('user/logout/', {
				method: 'POST',
			});
			commit('clearUserData', null)
			return {
				...response
			}
		},

		async requestUserInfoBanner({commit,dispatch}) {
			commit('startLoading', 'requestUserInfoBanner', {root: true})
			const response = await Fetch('/info/personal/banners/', {
				method: 'GET',
			});

			if (response.success) {
				commit('setUserInfoBanner', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestUserInfoBanner', {root: true})

			return {
				...response.data
			}
		},	
	},

	getters: {
		getUserData: state => state.userData,
		getFullUserData: state => state.fullUserData,
		getUserNotice: state => state.userNotice,
		getUserBanner: state => state.userBanner,
		checkUserRole: (state) => (role) => {
			return state.userData?.role?.toLowerCase() === role.toLowerCase()
		},
		getUserRole: (state) => {
			return state.userData?.role || null
		}
	}
}

